package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.image.Image
import com.wintermar.inspection.core.ui.component.image.util.FileModel
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun ImageGrid(
    files: List<FileModel> = listOf(),
    modifier: Modifier = Modifier,
    showDeleteButton: Boolean = false,
    minNumberOfColumn: Int = 3,
    width: Dp = LocalAppTheme.current.dimension.size.size12,
    height: Dp = LocalAppTheme.current.dimension.size.size12,
    onDelete: (FileModel) -> Unit = {}
) {
    // Calculate the required height so it doesn't try to scroll
    val rows = (files.size + minNumberOfColumn - 1) / minNumberOfColumn
    val spacing = LocalAppTheme.current.dimension.spacing.space3
    val totalHeight = (height * rows) + (spacing * (rows - 1).coerceAtLeast(0))

    LazyVerticalGrid(
        modifier = modifier.heightIn(max = totalHeight),
        columns = GridCells.Adaptive(width),
        verticalArrangement = Arrangement.spacedBy(
            space = LocalAppTheme.current.dimension.spacing.space3,
        ),
        horizontalArrangement = Arrangement.spacedBy(
            space = LocalAppTheme.current.dimension.spacing.space3,
        ),
        userScrollEnabled = false
    ) {
        items(files) {
            Image(
                file = it,
                showDeleteButton = showDeleteButton,
                width = width,
                height = height,
                onDelete = { onDelete(it) })
        }
    }
}
